/**
 * Re-export of the shared Newsletter component for the storefront renderer.
 * The base component (render + fields + defaults) lives in
 * `@launchstore/shared-puck`. The renderer uses it as-is — no
 * editor-specific field widgets.
 *
 * See launchstore-shared/src/puck/components/homepage/Newsletter/ for source.
 */
import { Newsletter as SharedNewsletter } from '@launchstore/shared-puck';

export const Newsletter: any = SharedNewsletter;
export type { NewsletterProps } from '@launchstore/shared-puck';
export default Newsletter;
